export const linkImagesTexts = {
  CELLAR: {
    image: {
      url: 'https://waitrose-prod.scene7.com/is/image/waitroseprod/wine-2?$Waitrose-Image-Preset-95$&wid=200&fit=constrain,0',
    },
    text: 'Explore more than 1,200 beers, wines and spirits',
    ariaLabel:
      'Waitrose Cellar. Explore more than 1,200 beers, wines and spirits. Opens in new window',
    className: 'imgBox cellar',
  },
  DISHPATCH: {
    image: {
      url: 'https://waitrose-prod.scene7.com/is/image/waitroseprod/dishpatch?$Waitrose-Image-Preset-95$&wid=160&fit=constrain,0',
    },
    text: 'Chef-created set menus, by restaurant-quality meal delivery experts Dishpatch.',
    ariaLabel:
      'Chef-created set menus, by restaurant-quality meal delivery experts Dishpatch. Opens in new window',
    className: 'imgBox dishpatch',
  },
};
